module.exports = __webpack_public_path__ + "static/img/1.4623cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/1.png
// module id = AD5K
// module chunks = 2